"use strict";
import { analytics } from "utilities/src/telemetry/analytics/analytics";
export var MobileUserPropertyName = /* @__PURE__ */ ((MobileUserPropertyName2) => {
  MobileUserPropertyName2["ActiveWalletAddress"] = "active_wallet_address";
  MobileUserPropertyName2["ActiveWalletType"] = "active_wallet_type";
  MobileUserPropertyName2["AdvertisingId"] = "advertising_id";
  MobileUserPropertyName2["AndroidPerfClass"] = "android_perf_class";
  MobileUserPropertyName2["AppOpenAuthMethod"] = "app_open_auth_method";
  MobileUserPropertyName2["AppVersion"] = "app_version";
  MobileUserPropertyName2["Currency"] = "currency";
  MobileUserPropertyName2["DarkMode"] = "is_dark_mode";
  MobileUserPropertyName2["HasLoadedENS"] = "has_loaded_ens";
  MobileUserPropertyName2["HasLoadedUnitag"] = "has_loaded_unitag";
  MobileUserPropertyName2["IsCloudBackedUp"] = "is_cloud_backed_up";
  MobileUserPropertyName2["IsHideSmallBalancesEnabled"] = "is_hide_small_balances_enabled";
  MobileUserPropertyName2["IsHideSpamTokensEnabled"] = "is_hide_spam_tokens_enabled";
  MobileUserPropertyName2["IsPushEnabled"] = "is_push_enabled";
  MobileUserPropertyName2["Language"] = "language";
  MobileUserPropertyName2["MnemonicCount"] = "mnemonic_count";
  MobileUserPropertyName2["TestnetModeEnabled"] = "testnet_mode_enabled";
  MobileUserPropertyName2["TransactionAuthMethod"] = "transaction_auth_method";
  MobileUserPropertyName2["WalletSignerAccounts"] = `wallet_signer_accounts`;
  MobileUserPropertyName2["WalletSignerCount"] = "wallet_signer_count";
  MobileUserPropertyName2["WalletSwapProtectionSetting"] = "wallet_swap_protection_setting";
  MobileUserPropertyName2["WalletViewOnlyCount"] = "wallet_view_only_count";
  MobileUserPropertyName2["WindowHeight"] = "window_height";
  MobileUserPropertyName2["WindowWidth"] = "window_width";
  return MobileUserPropertyName2;
})(MobileUserPropertyName || {});
export var ExtensionUserPropertyName = /* @__PURE__ */ ((ExtensionUserPropertyName2) => {
  ExtensionUserPropertyName2["ActiveWalletAddress"] = "active_wallet_address";
  ExtensionUserPropertyName2["ActiveWalletType"] = "active_wallet_type";
  ExtensionUserPropertyName2["AppVersion"] = "app_version";
  ExtensionUserPropertyName2["Currency"] = "currency";
  ExtensionUserPropertyName2["DarkMode"] = "is_dark_mode";
  ExtensionUserPropertyName2["IsHideSmallBalancesEnabled"] = "is_hide_small_balances_enabled";
  ExtensionUserPropertyName2["IsHideSpamTokensEnabled"] = "is_hide_spam_tokens_enabled";
  ExtensionUserPropertyName2["Language"] = "language";
  ExtensionUserPropertyName2["TestnetModeEnabled"] = "testnet_mode_enabled";
  ExtensionUserPropertyName2["WalletSignerAccounts"] = `wallet_signer_accounts`;
  ExtensionUserPropertyName2["WalletSignerCount"] = "wallet_signer_count";
  ExtensionUserPropertyName2["WalletViewOnlyCount"] = "wallet_view_only_count";
  return ExtensionUserPropertyName2;
})(ExtensionUserPropertyName || {});
export var InterfaceUserPropertyName = /* @__PURE__ */ ((InterfaceUserPropertyName2) => {
  InterfaceUserPropertyName2["IsDelegatedEOA"] = "is_delegated_eoa";
  InterfaceUserPropertyName2["SupportsAtomicBatching"] = "supports_atomic_batching";
  return InterfaceUserPropertyName2;
})(InterfaceUserPropertyName || {});
export function setUserProperty(property, value, insert) {
  analytics.setUserProperty(property, value, insert);
}
